module.exports = __webpack_public_path__ + "media/images/plus_icon-fcd0e459ac6633357c4375159d671906.png";